// extracted by css-extract-rspack-plugin
export default {"link":"customLinkTab-module__link","title":"customLinkTab-module__title"};